var map = {
	"./App": 5788,
	"./App.vue": 5788,
	"./assets/icons/apis-black.png": 6044,
	"./assets/icons/apis-green.png": 3196,
	"./assets/icons/apps-black.png": 1855,
	"./assets/icons/apps-green.png": 5391,
	"./assets/icons/arrows-black-2.png": 4568,
	"./assets/icons/arrows-black.png": 8137,
	"./assets/icons/arrows-green.png": 6753,
	"./assets/icons/arrows-green.svg": 7471,
	"./assets/icons/websites-black.png": 8393,
	"./assets/icons/websites-green.png": 2529,
	"./assets/logos/logo (1).png": 744,
	"./assets/logos/logo-bunk.png": 2367,
	"./assets/logos/logo-wrong-size.png": 3970,
	"./assets/logos/logo.png": 6918,
	"./assets/logos/logo.svg": 9128,
	"./assets/logos/logo2.png": 1942,
	"./assets/logos/logo2.svg": 2154,
	"./assets/screenshots/analysis1.png": 8307,
	"./assets/screenshots/analysis2.png": 3816,
	"./assets/screenshots/picking_inventory.png": 3716,
	"./assets/screenshots/receiving_load_main.png": 2727,
	"./assets/screenshots/receiving_load_media.png": 2406,
	"./assets/screenshots/slo_dashboard.png": 2569,
	"./assets/screenshots/slo_lead_assignment_notes.png": 6929,
	"./assets/screenshots/wms_mobile_home.png": 5970,
	"./components/SolutionGrid": 1985,
	"./components/SolutionGrid.vue": 1985,
	"./components/SolutionItem": 9309,
	"./components/SolutionItem.vue": 9309,
	"./components/TextGrid": 7278,
	"./components/TextGrid.vue": 7278,
	"./components/TextGridItem": 999,
	"./components/TextGridItem.vue": 999,
	"./components/gallery": 1187,
	"./components/gallery/": 1187,
	"./components/gallery/fancy/Gallery": 3169,
	"./components/gallery/fancy/Gallery.vue": 3169,
	"./components/gallery/fancy/GalleryItem": 8421,
	"./components/gallery/fancy/GalleryItem.vue": 8421,
	"./components/gallery/index": 1187,
	"./components/gallery/index.vue": 1187,
	"./components/gallery/simple/Gallery": 3710,
	"./components/gallery/simple/Gallery.vue": 3710,
	"./components/gallery/simple/GalleryItem": 7546,
	"./components/gallery/simple/GalleryItem.vue": 7546,
	"./components/header/SiteHeader": 1334,
	"./components/header/SiteHeader.vue": 1334,
	"./components/lightbox/LightBox": 2950,
	"./components/lightbox/LightBox.vue": 2950,
	"./components/menu/Menu": 3839,
	"./components/menu/Menu.vue": 3839,
	"./components/menu/desktop/Navbar": 5175,
	"./components/menu/desktop/Navbar.vue": 5175,
	"./components/menu/mobile/HamburgerMenu": 3894,
	"./components/menu/mobile/HamburgerMenu.vue": 3894,
	"./data/menu_screens": 571,
	"./data/menu_screens.json": 571,
	"./data/portfolio": 4318,
	"./data/portfolio.json": 4318,
	"./data/solutions": 1274,
	"./data/solutions.json": 1274,
	"./main": 1406,
	"./main.js": 1406,
	"./router": 9325,
	"./router/": 9325,
	"./router/index": 9325,
	"./router/index.js": 9325,
	"./router/routes": 3723,
	"./router/routes.js": 3723,
	"./store": 5129,
	"./store/": 5129,
	"./store/index": 5129,
	"./store/index.js": 5129,
	"./styles/colors.scss": 2059,
	"./styles/elements.scss": 9422,
	"./styles/responsive.scss": 1297,
	"./styles/spacings.scss": 6005,
	"./styles/transitions.scss": 4025,
	"./styles/typography.scss": 7854,
	"./utils": 1981,
	"./utils/": 1981,
	"./utils/index": 1981,
	"./utils/index.js": 1981,
	"./views": 3882,
	"./views/": 3882,
	"./views/About": 181,
	"./views/About.vue": 181,
	"./views/Contact": 2681,
	"./views/Contact.vue": 2681,
	"./views/Portfolio": 8828,
	"./views/Portfolio.vue": 8828,
	"./views/Solutions": 7478,
	"./views/Solutions.vue": 7478,
	"./views/index": 3882,
	"./views/index.js": 3882
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5538;